import script from "./PaginateWithCount.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginateWithCount.vue?vue&type=script&setup=true&lang=ts"

import "./PaginateWithCount.vue?vue&type=style&index=0&id=8aadad4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8aadad4a"]])

export default __exports__